import React from "react";

/**
 * Premium ikon kütüphanesi — emoji yerine 1.5px stroke minimal SVG.
 * Hepsi currentColor kullanır; kapsayan öğenin rengini alır.
 *
 * Kullanım:
 *   import { IcFire, IcChair } from "./Icons";
 *   <IcFire />
 *   <IcFire size={20} className="mr-1" />
 */

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const Icon = ({ size = 18, className = "", style = {}, children }) => (
  <svg
    width={size}
    height={size}
    className={className}
    style={style}
    {...base}
    aria-hidden="true"
  >
    {children}
  </svg>
);

// ── Navigation / Layout ─────────────────────────────────────────────

export const IcFire = (p) => (
  <Icon {...p}>
    <path d="M8.5 14.5A2.5 2.5 0 0011 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 11-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 002.5 2.5z" />
  </Icon>
);

export const IcChair = (p) => (
  <Icon {...p}>
    <path d="M6 10V6a2 2 0 012-2h8a2 2 0 012 2v4" />
    <path d="M4 10h16v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2z" />
    <path d="M6 14v6M18 14v6M8 18h8" />
  </Icon>
);

export const IcCheck = (p) => (
  <Icon {...p}>
    <path d="M20 6L9 17l-5-5" />
  </Icon>
);

export const IcChart = (p) => (
  <Icon {...p}>
    <path d="M3 3v18h18" />
    <path d="M7 15V9M12 15V6M17 15v-4" />
  </Icon>
);

export const IcSettings = (p) => (
  <Icon {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 00.34 1.87l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.7 1.7 0 00-1.87-.34 1.7 1.7 0 00-1.03 1.56V21a2 2 0 01-4 0v-.09a1.7 1.7 0 00-1.11-1.56 1.7 1.7 0 00-1.87.34l-.06.06a2 2 0 01-2.83-2.83l.06-.06a1.7 1.7 0 00.34-1.87 1.7 1.7 0 00-1.56-1.03H3a2 2 0 010-4h.09a1.7 1.7 0 001.56-1.11 1.7 1.7 0 00-.34-1.87l-.06-.06a2 2 0 012.83-2.83l.06.06a1.7 1.7 0 001.87.34H9a1.7 1.7 0 001.03-1.56V3a2 2 0 014 0v.09a1.7 1.7 0 001.03 1.56 1.7 1.7 0 001.87-.34l.06-.06a2 2 0 012.83 2.83l-.06.06a1.7 1.7 0 00-.34 1.87V9a1.7 1.7 0 001.56 1.03H21a2 2 0 010 4h-.09a1.7 1.7 0 00-1.56 1.03z" />
  </Icon>
);

export const IcMonitor = (p) => (
  <Icon {...p}>
    <rect x="2" y="4" width="20" height="12" rx="2" />
    <path d="M8 20h8M12 16v4" />
  </Icon>
);

// ── Admin ─────────────────────────────────────────────────────────

export const IcBox = (p) => (
  <Icon {...p}>
    <path d="M21 8l-9-5-9 5v8l9 5 9-5V8z" />
    <path d="M3 8l9 5 9-5M12 13v10" />
  </Icon>
);

export const IcFolder = (p) => (
  <Icon {...p}>
    <path d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" />
  </Icon>
);

export const IcStar = (p) => (
  <Icon {...p}>
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  </Icon>
);

export const IcMoney = (p) => (
  <Icon {...p}>
    <circle cx="12" cy="14" r="7" />
    <path d="M12 10v8M9 12h5a1.5 1.5 0 010 3H9a1.5 1.5 0 000 3h6" />
    <path d="M8 4l1.5 3M16 4l-1.5 3" />
  </Icon>
);

export const IcUsers = (p) => (
  <Icon {...p}>
    <path d="M17 20v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 20v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
  </Icon>
);

// ── Expenses / Utility ─────────────────────────────────────────────

export const IcBolt = (p) => (
  <Icon {...p}>
    <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />
  </Icon>
);

export const IcDroplet = (p) => (
  <Icon {...p}>
    <path d="M12 2s7 7.6 7 13a7 7 0 01-14 0c0-5.4 7-13 7-13z" />
  </Icon>
);

export const IcHouse = (p) => (
  <Icon {...p}>
    <path d="M3 11.5L12 4l9 7.5" />
    <path d="M5 10v9.5a1 1 0 001 1h3.5v-6h5v6H18a1 1 0 001-1V10" />
  </Icon>
);

export const IcMemo = (p) => (
  <Icon {...p}>
    <path d="M14 3H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V9l-6-6z" />
    <path d="M14 3v6h6M9 14h6M9 17h4" />
  </Icon>
);

export const IcTrend = (p) => (
  <Icon {...p}>
    <path d="M3 17l6-6 4 4 8-8" />
    <path d="M14 7h7v7" />
  </Icon>
);

export const IcClipboard = (p) => (
  <Icon {...p}>
    <rect x="5" y="4" width="14" height="18" rx="2" />
    <rect x="9" y="2" width="6" height="4" rx="1" />
    <path d="M9 12h6M9 16h4" />
  </Icon>
);

export const IcSave = (p) => (
  <Icon {...p}>
    <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
    <path d="M17 21v-8H7v8M7 3v5h8" />
  </Icon>
);

export const IcWarning = (p) => (
  <Icon {...p}>
    <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
    <path d="M12 9v4M12 17h.01" />
  </Icon>
);

export const IcTrash = (p) => (
  <Icon {...p}>
    <path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" />
  </Icon>
);

// ── Ayarlar / Actions ──────────────────────────────────────────────

export const IcBell = (p) => (
  <Icon {...p}>
    <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 01-3.4 0" />
  </Icon>
);

export const IcCoffee = (p) => (
  <Icon {...p}>
    <path d="M17 8h1a4 4 0 010 8h-1" />
    <path d="M3 8h14v9a4 4 0 01-4 4H7a4 4 0 01-4-4V8z" />
    <path d="M6 2v3M10 2v3M14 2v3" />
  </Icon>
);

export const IcCamera = (p) => (
  <Icon {...p}>
    <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" />
    <circle cx="12" cy="13" r="4" />
  </Icon>
);

export const IcPhone = (p) => (
  <Icon {...p}>
    <rect x="6" y="2" width="12" height="20" rx="2.5" />
    <path d="M11 18h2" />
  </Icon>
);

export const IcQr = (p) => (
  <Icon {...p}>
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <path d="M14 14h3v3M21 14v7h-7M17 21h.01M21 17h.01" />
  </Icon>
);

/**
 * Ürün amblemi — default ("☕" veya boş) → temiz IcCoffee ikonu,
 * admin'in seçtiği gerçek özel emoji → olduğu gibi gösterir.
 * Böylece 100 üründe tekrarlanan aynı fincan emojisi premium ikona döner,
 * ama özel emojili ürünler (🍹, 🍰 vb.) kendi emojisini korur.
 */
export function ProductGlyph({ emoji, size = 22, style = {} }) {
  if (!emoji || emoji === "☕") {
    return <IcCoffee size={size} style={style} />;
  }
  return <span style={{ fontSize: size, lineHeight: 1, ...style }}>{emoji}</span>;
}

export const IcLock = (p) => (
  <Icon {...p}>
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0110 0v4" />
  </Icon>
);

export const IcUnlock = (p) => (
  <Icon {...p}>
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 019.9-1" />
  </Icon>
);

// ── Payments / Dashboard ───────────────────────────────────────────

export const IcCard = (p) => (
  <Icon {...p}>
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <path d="M2 10h20" />
  </Icon>
);

export const IcCash = (p) => (
  <Icon {...p}>
    <rect x="2" y="6" width="20" height="12" rx="2" />
    <circle cx="12" cy="12" r="3" />
    <path d="M6 12h.01M18 12h.01" />
  </Icon>
);

export const IcTrophy = (p) => (
  <Icon {...p}>
    <path d="M6 9H4a2 2 0 01-2-2V5h4M18 9h2a2 2 0 002-2V5h-4" />
    <path d="M6 5h12v7a6 6 0 01-12 0V5z" />
    <path d="M9 21h6M12 17v4" />
  </Icon>
);

export const IcCalendar = (p) => (
  <Icon {...p}>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M16 3v4M8 3v4M3 10h18" />
  </Icon>
);

// ── Order flow ────────────────────────────────────────────────────

export const IcCart = (p) => (
  <Icon {...p}>
    <circle cx="9" cy="21" r="1.5" />
    <circle cx="18" cy="21" r="1.5" />
    <path d="M2 3h3l2.68 12.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" />
  </Icon>
);

export const IcReceipt = (p) => (
  <Icon {...p}>
    <path d="M4 3v18l3-2 3 2 3-2 3 2 3-2 3 2V3l-3 2-3-2-3 2-3-2-3 2-3-2z" />
    <path d="M8 8h8M8 12h8M8 16h5" />
  </Icon>
);

export const IcPin = (p) => (
  <Icon {...p}>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
    <circle cx="12" cy="10" r="3" />
  </Icon>
);

export const IcPlus = (p) => (
  <Icon {...p}>
    <path d="M12 5v14M5 12h14" />
  </Icon>
);

export const IcSearch = (p) => (
  <Icon {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4.35-4.35" />
  </Icon>
);

export const IcEdit = (p) => (
  <Icon {...p}>
    <path d="M12 20h9M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z" />
  </Icon>
);

export const IcClock = (p) => (
  <Icon {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </Icon>
);

export const IcRefresh = (p) => (
  <Icon {...p}>
    <path d="M23 4v6h-6M1 20v-6h6" />
    <path d="M3.51 9A9 9 0 0118 5.4l5 5M1 14l5 5A9 9 0 0020.49 15" />
  </Icon>
);

export const IcChat = (p) => (
  <Icon {...p}>
    <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
  </Icon>
);

export const IcSend = (p) => (
  <Icon {...p}>
    <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
  </Icon>
);

export const IcPrinter = (p) => (
  <Icon {...p}>
    <path d="M6 9V3h12v6M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2" />
    <rect x="6" y="14" width="12" height="8" />
  </Icon>
);

// ── Ayarlar / Sistem ───────────────────────────────────────────────

export const IcMail = (p) => (
  <Icon {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </Icon>
);

export const IcLink = (p) => (
  <Icon {...p}>
    <path d="M9 15a5 5 0 007.07 0l2.5-2.5a5 5 0 00-7.07-7.07l-1.25 1.25" />
    <path d="M15 9a5 5 0 00-7.07 0l-2.5 2.5a5 5 0 007.07 7.07l1.25-1.25" />
  </Icon>
);

export const IcPalette = (p) => (
  <Icon {...p}>
    <path d="M12 3a9 9 0 100 18c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.24-.27-.39-.62-.39-1.01 0-.83.67-1.5 1.5-1.5H16a5 5 0 005-5c0-4.42-4.03-8-9-8z" />
    <circle cx="7.5" cy="11.5" r="1" fill="currentColor" stroke="none" />
    <circle cx="11" cy="7.5" r="1" fill="currentColor" stroke="none" />
    <circle cx="15.5" cy="8.5" r="1" fill="currentColor" stroke="none" />
  </Icon>
);

export const IcSparkle = (p) => (
  <Icon {...p}>
    <path d="M12 4l1.6 4.4L18 10l-4.4 1.6L12 16l-1.6-4.4L6 10l4.4-1.6z" />
    <path d="M18.5 4.5v3M20 6h-3" />
  </Icon>
);

export const IcKey = (p) => (
  <Icon {...p}>
    <circle cx="8" cy="8" r="4" />
    <path d="M10.85 10.85L20 20M17 17l2-2M15 19l1.5-1.5" />
  </Icon>
);

export const IcUser = (p) => (
  <Icon {...p}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21a8 8 0 0116 0" />
  </Icon>
);

export const IcVolume = (p) => (
  <Icon {...p}>
    <path d="M11 5L6 9H3v6h3l5 4V5z" />
    <path d="M15.5 8.5a5 5 0 010 7M18.5 5.5a9 9 0 010 13" />
  </Icon>
);

export const IcScale = (p) => (
  <Icon {...p}>
    <path d="M12 3v17M7 20h10M5 7h14M8 5l-4 1 4-1 8-2" />
    <path d="M4 6l-2.5 6h5zM20 6l-2.5 6h5z" />
    <path d="M1.5 12a2.5 2.5 0 005 0M17.5 12a2.5 2.5 0 005 0" />
  </Icon>
);

export const IcWrench = (p) => (
  <Icon {...p}>
    <path d="M14.5 6.5a4 4 0 00-5.2 5.2l-5.6 5.6a1.5 1.5 0 002.1 2.1l5.6-5.6a4 4 0 005.2-5.2l-2.4 2.4-2.1-2.1z" />
  </Icon>
);

export const IcInfo = (p) => (
  <Icon {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5M12 7.5h.01" />
  </Icon>
);
